import { css as _css } from "@emotion/core";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { TabBar } from '@domain-group/fe-co-allhomes-tabbed-panel';
import { BodySection } from '@domain-group/fe-co-allhomes-design-system';
import { ArticleCards } from './article-cards';
import * as styles from './news-block.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewsBlock = _ref => {
  var _ref$articleGroups = _ref.articleGroups,
    articleGroups = _ref$articleGroups === void 0 ? [] : _ref$articleGroups;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var tabs = articleGroups.map(articleGroup => ({
    id: articleGroup.identifier,
    label: articleGroup.label
  }));
  return ___EmotionJSX(BodySection, {
    css: styles.newsBlock
  }, ___EmotionJSX("div", {
    css: styles.titleBlock
  }, ___EmotionJSX("h2", {
    css: styles.title
  }, "Property news & advice"), articleGroups.length > 1 && ___EmotionJSX(TabBar, {
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabWrapper
    }),
    activeIndex: tabIndex,
    tabs: tabs,
    onClick: idx => {
      sendEvent('news-tab-click', {
        tabLabel: tabs[idx].label
      });
      setTabIndex(idx);
    }
  })), ___EmotionJSX("div", {
    css: styles.articlesList
  }, articleGroups.map((articleGroup, groupIndex) => ___EmotionJSX("div", {
    key: articleGroup.label,
    css: /*#__PURE__*/_css([styles.panelContent, tabIndex !== groupIndex && styles.hidden])
  }, ___EmotionJSX(ArticleCards, {
    articles: articleGroup.articles,
    sectionName: articleGroup.label
  })))));
};
NewsBlock.propTypes = {
  articleGroups: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    articles: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      image: PropTypes.string,
      tags: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string
      }))
    })).isRequired
  })).isRequired
};
export { NewsBlock };